import GlobalAxios from "../axios/axios-config";

export interface ITasySchedMenu {
  id: string;
  name: string;
  displayOrder: number;
  ticketAutomationReceivedRule?: {
    id: string;
    name?: string;
    code: number;
  } | null;
  customMessage?: string | null;
}

export interface ITicketAutomationReceivedRuleInsuranceCategory {
  id: string;
  insuranceExternalId: string;
  insuranceExternalName: string;
  enable: boolean;
}

export interface ITicketAutomationReceivedRulePrivateInsurance {
  id: string;
  externalId: string;
  externalName: string;
}

export interface ITicketAutomationReceivedCustomMessageExternal {
  id: string;
  externalId: string;
  externalName: string;
}

export interface ITicketAutomationReceivedCustomMessage {
  id: string;
  message: string;
  ticketAutomationReceivedCaleExamGroupings: ITicketAutomationReceivedCustomMessageExternal[];
  ticketAutomationReceivedCustomMessageCalendars: ITicketAutomationReceivedCustomMessageExternal[];
}

export interface ITicketAutomationReceivedRuleEstablishment {
  id: string;
  establishmentId: string;
  establishmentName: string;
  integrationId: string;
}

export interface ITicketAutomationReceivedRule {
  id: string;
  code: number;
  name: string;
  errorMessage?: string | null;
  ticketAutomationCode: string;
  ticketAutomationName: string;
  ticketAutomationReceivedRuleAllowedAction?: ITicketAutomationReceivedRuleAllowedAction | null;
  ticketAutomationReceivedMessagePrivateInsurances: ITicketAutomationReceivedRulePrivateInsurance[];
  ticketAutomationReceivedRuleInsuranceCategories: ITicketAutomationReceivedRuleInsuranceCategory[];
  ticketAutomationReceivedRuleEstablishments: ITicketAutomationReceivedRuleEstablishment[];
  ticketAutomationReceivedCustomMessages: ITicketAutomationReceivedCustomMessage[];
  ticketAutRecRuleTasyOrientations: ITicketAutRecRuleTasyOrientation[];
}

export interface ITicketAutomationReceivedRuleReference {
  id: string;
  code: number;
  name: string;
  errorMessage?: string | null;
  ticketAutomationReceivedRuleCancelationReasons: ITicketAutomationReceivedRuleCancelationReason[];
  calendarClassificationCodes: string[];
  calendarIdentifiers: string[];
}

export interface ITicketAutomationReceivedRuleCancelationReason {
  id: string;
  externalId: string;
  externalName: string;
}

export interface ITicketAutomationReceivedRuleRescheduleContext {
  ruleId: string;
  individualId: string;
  individualName: string;
}

export interface ITicketAutomationReceivedRuleAllowedAction {
  id: string;
  newSchedule: boolean;
  reschedule: boolean;
  confirm: boolean;
  cancel: boolean;
  checkIn: boolean;
  featuredTicketAutomationReceivedRule?: ITicketAutomationReceivedRuleReference | null;
  returnTicketAutomationReceivedRule?: ITicketAutomationReceivedRuleReference | null;
  examTicketAutomationReceivedRule?: ITicketAutomationReceivedRuleReference | null;
  consultationTicketAutomationReceivedRule?: ITicketAutomationReceivedRuleReference | null;
}

export interface ITicketAutRecRuleTasyOrientation {
  id: string;
  enable: boolean;
  typeTasyOrientation: {
    id: string;
    identifier: string;
    code?: string | null;
    value?: string | null;
  };
  sendWhen: {
    id: string;
    identifier: string;
    code?: string | null;
    value?: string | null;
  };
}

const TASY_SCHED_MENU_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/TasySchedMenu";

export const getTasySchedMenus = () => {
  return GlobalAxios.get<ITasySchedMenu[]>(TASY_SCHED_MENU_ROUTE + "/list");
};

export const getTasySchedMenu = (id: string) => {
  return GlobalAxios.get<ITasySchedMenu>(`${TASY_SCHED_MENU_ROUTE}/${id}`);
};

export const getTicketAutomationReceivedRule = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedRule>(
    `${TASY_SCHED_MENU_ROUTE}/TicketAutomationReceivedRule/${id}`,
  );
};

export const getTicketAutomationReceivedRuleByAutomationCode = (
  automationCode: string,
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRule>(
    `${TASY_SCHED_MENU_ROUTE}/TicketAutomationReceivedRule/automation/${automationCode}`,
  );
};

export const getTicketAutomationReceivedRuleRescheduleContext = (params: {
  myAppointmentsRuleId: string;
  tasyScheduleTypeCode: string;
  calendarIdentifier?: string;
  calendarPreferenceCodes?: string;
  calendarClassificationCode?: string;
  medicalSpecialtyCode?: string;
  individualIntegrationId: string;
}) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleRescheduleContext>(
    `${TASY_SCHED_MENU_ROUTE}/TicketAutomationReceivedRule/reschedule`,
    { params },
  );
};
